import { Link } from "react-router-dom";
import { useTheme } from "@/hooks/useTheme";

const ahisFeedbackFormUrl =
  "https://docs.google.com/forms/d/e/1FAIpQLSeETVSBPO16xyK_48EwDz-Vg-1hlD0_K9pXKRDEjbAkJNN6lA/viewform?usp=publish-editor";

export default function Footer() {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <footer className="w-full bg-gray-50 dark:bg-dark-card border-t border-gray-200 dark:border-dark-border">
      <div className="px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img
                src={
                  isDark
                    ? "https://storage.readdy-site.link/project_files/47b2e0f1-f782-46fd-9795-faa524ec7a75/6f680f81-acb5-43c1-987a-0f33b54ce907_Presuni-logo-icon-1.png?v=b7ba9735e9e07e665ff0b08f3d253af5"
                    : "https://static.readdy.ai/image/cd6790f2d50eb1ecfa87fc97aafdc7d9/60656d058e98f3c366b059b99267fdcc.png"
                }
                alt="Presuni"
                className="h-7 w-auto"
              />
              <span className="text-lg font-bold text-gray-900 dark:text-white">
                PRESUNI
              </span>
            </div>
            <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
              Enterprise IT services, cybersecurity, and software engineering since 2006.
            </p>
            <p className="text-xs text-gray-400 dark:text-gray-500 mt-2">
              Company Reg: 05745823
            </p>
            <div className="flex items-center gap-3 mt-3">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-200 dark:bg-dark-border text-gray-500 dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-300 transition-colors"
              >
                <i className="ri-linkedin-fill text-sm" />
              </a>
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-200 dark:bg-dark-border text-gray-500 dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-300 transition-colors"
              >
                <i className="ri-github-fill text-sm" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-200 dark:bg-dark-border text-gray-500 dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-300 transition-colors"
              >
                <i className="ri-instagram-fill text-sm" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-200 dark:bg-dark-border text-gray-500 dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-300 transition-colors"
              >
                <i className="ri-facebook-fill text-sm" />
              </a>
              <a
                href="https://x.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-200 dark:bg-dark-border text-gray-500 dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-300 transition-colors"
              >
                <i className="ri-twitter-x-fill text-sm" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-4">
              Services
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/services" className="text-sm text-gray-500 dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-300 hover:underline underline-offset-2 transition-colors">
                  Cybersecurity
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-gray-500 dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-300 hover:underline underline-offset-2 transition-colors">
                  Software Engineering
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-gray-500 dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-300 hover:underline underline-offset-2 transition-colors">
                  IT Consulting
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-4">
              Products
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/ahis" className="text-sm text-gray-500 dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-300 hover:underline underline-offset-2 transition-colors">
                  AHIS
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-4">
              Company
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/contact" className="text-sm text-gray-500 dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-300 hover:underline underline-offset-2 transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <a href="mailto:info@presuni.co.uk" className="text-sm text-gray-500 dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-300 hover:underline underline-offset-2 transition-colors" rel="nofollow">
                  info@presuni.co.uk
                </a>
              </li>
              <li>
                <a href="tel:+447788132263" className="text-sm text-gray-500 dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-300 hover:underline underline-offset-2 transition-colors" rel="nofollow">
                  +44 (0) 7788 1322 63
                </a>
              </li>
              <li>
                <a
                  href={ahisFeedbackFormUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-500 dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-300 hover:underline underline-offset-2 transition-colors"
                >
                  AHIS Feedback Form
                </a>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-gray-500 dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-300 hover:underline underline-offset-2 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-gray-500 dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-300 hover:underline underline-offset-2 transition-colors">
                  Terms &amp; Conditions
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 dark:border-dark-border flex items-center justify-center">
          <p className="text-xs text-gray-400 dark:text-gray-500">
            &copy; {new Date().getFullYear()} Presuni Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
